// Shared date/time formatters
// formatDateTime: dd/mm/yyyy hh:mm
// formatDate: dd/mm/yyyy

export const formatDateTime = (iso) => {
    if (!iso) return '—';
    const t = Date.parse(iso);
    if (isNaN(t)) return String(iso);
    const d = new Date(t);
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}`;
};

export const formatDate = (iso) => {
    if (!iso) return '—';
    // ISO-only fast path
    const m = String(iso).match(/^(\d{4})-(\d{1,2})-(\d{1,2})/);
    if (m) {
        const [, y, mo, d] = m;
        return `${d.padStart(2, '0')}/${mo.padStart(2, '0')}/${y}`;
    }
    const t = Date.parse(iso);
    if (isNaN(t)) return String(iso);
    const d = new Date(t);
    const pad = (n) => String(n).padStart(2, '0');
    return `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()}`;
};
